/* ==================================================
 *  Fullscreen
 * ==================================================*/

function fullscreen(classItem) {

  'use strict';

  var $target = $('body');

  $(document).on('click', '[data-fullscreen="' + classItem + '"]', function (ev) {
    ev.preventDefault();
    $target.toggleClass(classItem + '--fullscreen').toggleClass('overflow-hidden');
  });
}
